<template>
  <div class="grid grid-cols-4 gap-2">
    <button
      v-for="number in months"
      :key="number"
      :class="
        selectedMonth === number
          ? 'bg-ontick-blue-600'
          : 'bg-ontick-steel-500 filter transition-all hover:brightness-125'
      "
      class="rounded py-1 px-3 font-semibold"
      @click="selectMonth(number)"
    >
      {{ moment().month(number).format("MMM").toUpperCase() }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    selectedMonth: {
      type: Number,
    },
  },

  computed: {
    months() {
      let arr = [];
      for (let i = 0; i < 12; i++) {
        arr.push(i);
      }
      return arr;
    },
  },

  methods: {
    selectMonth(number) {
      this.$emit("select-month", number);
    },
  },
};
</script>

<style></style>
